<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9872 40.2559L4.5 33.0151V14.189M4.5 14.189L20.2949 5.5L37.5256 14.189M4.5 14.189L20.2949 22.878M37.5256 14.189V30.1188M37.5256 14.189L20.2949 22.878M20.2949 22.878V31.5669M24.6026 38.8078C27.953 37.3596 33.2179 37.3596 33.2179 41.7041C33.2179 47.4967 30.3462 47.4967 26.0385 47.4967C26.0385 47.4967 33.2179 47.4967 33.2179 54.7376C33.2179 59.082 26.0385 59.082 23.1667 57.6339M44.7051 37.3596V57.6339C51.8846 57.6339 60.5 56.765 60.5 47.4967C60.5 38.2285 51.8846 37.3596 44.7051 37.3596Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
